// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'first-login-signature-spinner',
    templateUrl: './first-login-signature-spinner.component.html',
    styleUrls: ['./first-login-signature-spinner.component.scss'],
})
export class FirstLoginSignatureSpinnerComponent implements OnInit {
    @Input() needSignatures = true;

    get phrases(): string[] {
        if (this.needSignatures) {
            return ['Storing to Signature Image to the DDJ Secure Vault', 'Storing Your Initial Image to the  DDJ Secure Vault', 'Almost Complete…'];
        } else {
            return [];
        }
    }

    ngOnInit(): void {
        this.changePhrase(this.phrases);
    }

    changePhrase(arr) {
        const phrase = document.getElementById('phrase');
        for (let i = 0; i < arr.length; i++) {
            // for each iteration console.log a word
            // and make a pause after it

            (function (i) {
                setTimeout(function () {
                    if (arr[i].length <= 0) {
                        arr = [''];
                    } else {
                        phrase.innerHTML = arr[i];
                    }
                }, 2500 * i);
            })(i);
        }
    }
}
